module.exports = __webpack_public_path__ + "img/pk.8bb41566.svg";